import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { addContactUsData } from "services/_contactUs";
import { successToast } from "components/toast";
import { errorToast } from "components/toast";
import Spondyloarthritis from "./components/Spondyloarthritis";

const Contact = () => {
  const handleSubmit = async (values, { resetForm }) => {
    const response = await addContactUsData(values);
    if (response.isSuccess) {
      successToast(response.message);
      resetForm();
    } else {
      errorToast(response.message);
    }
  };

  const subjects = [
    { value: "Feedback on A-tool", label: "Feedback on A-Tool" },
    {
      value: "Help us improve the website",
      label: "Help us improve the website",
    },
    {
      value: "Reach out regarding collaboration or sponsorship",
      label: "Reach out regarding collaboration or sponsorship",
    },
    {
      value: "Invitation to meet, lecture or advisory board",
      label: "Invitation to meet, lecture or advisory board",
    },
    { value: "Other", label: "Other" },
  ];

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    subject: "Feedback on A-tool",
    message: "",
    country: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required field."),
    email: Yup.string()
      .required("Email is required")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email format"),
    phone: Yup.string()
      .matches(
        /^\d{10}$/,
        "Phone number must be exactly 10 digits and contain only numbers."
      )
      .optional(),
    subject: Yup.string().optional(),
    message: Yup.string().required("Message is required field."),
    country: Yup.string().optional(),
  });

  return (
    <div className="bg-[#fff]">
      <div className="body_overly"></div>

      <section className="pt-[15px] max-w-[1200px]  w-full  mx-auto ">
        <div className="container contact">
          <h1 className="font-bold md:text-[36px] text-[28px]  text-center text-[#  225491]">
            Get in touch
          </h1>
          <h3 className="max-w-[700px] my-[5px] mx-auto text-center md:text-[20px] text-[14px] font-[500] text-[#112344]">
            We’re here to help. Reach out to us through any of the following
            methods, and we’ll respond as soon as possible.
          </h3>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form className="md:my-[50px] my-[15px]">
                <div className="grid grid-cols-1 md:grid-cols-3 md:gap-[35px] gap-[15px]">
                  <div className="input_box">
                    <label
                      className="md:text-[16px] text-[14px] font-[600] m-0 text-dark"
                      htmlFor="name"
                    >
                      Name<span style={{ color: "red" }}> *</span>
                    </label>
                    <Field
                      type="text"
                      name="name"
                      id="name"
                      className="input"
                      placeholder="Name"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                  <div className="input_box">
                    <label
                      className="md:text-[16px] text-[14px] font-[600] m-0 text-dark"
                      htmlFor="email"
                    >
                      Email<span style={{ color: "red" }}> *</span>
                    </label>
                    <Field
                      type="text"
                      name="email"
                      id="email"
                      className="input"
                      placeholder="Email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                  <div className="input_box">
                    <label
                      className="md:text-[16px] text-[14px] font-[600] m-0 text-dark"
                      htmlFor="phone"
                    >
                      Phone
                    </label>
                    <Field
                      type="text"
                      name="phone"
                      id="phone"
                      className="input"
                      placeholder="Phone"
                    />
                    <ErrorMessage
                      name="phone"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 my-[20px] md:gap-[35px] gap-[15px]">
                  <div className="input_box">
                    <label
                      className="md:text-[16px] text-[14px] font-[600] m-0 text-dark"
                      htmlFor="country"
                    >
                      Country
                    </label>
                    <Field
                      type="text"
                      name="country"
                      id="country"
                      className="input"
                      placeholder="country"
                    />
                    <ErrorMessage
                      name="country"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                  <div className="input_box">
                    <label
                      className="md:text-[16px] text-[14px] font-[600] m-0 text-dark"
                      htmlFor="subject"
                    >
                      Subject
                    </label>
                    <Field
                      as="select"
                      name="subject"
                      className="input"
                      id="subject"
                    >
                      {subjects.map((subj) => (
                        <option key={subj.value} value={subj.value}>
                          {subj.label}
                        </option>
                      ))}
                    </Field>
                  </div>
                </div>

                <div className="grid grid-cols-1">
                  <div className="input_box">
                    <label
                      className="md:text-[16px] text-[14px] font-[600] m-0 text-dark"
                      htmlFor="message"
                    >
                      Message <span style={{ color: "red" }}> *</span>
                    </label>
                    <Field
                      as="textarea"
                      name="message"
                      id="message"
                      className="input min-h-[200px]"
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="subscribe_btn md:h-[48px] h-[34px] md:max-w-[166px] max-w-[130px] md:text-[18px] text-[16px]"
                >
                  Submit
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </section>

      <Spondyloarthritis />
    </div>
  );
};

export default Contact;
